import { useMutation, type UseMutationOptions } from '@tanstack/react-query';

import { scanDeliveryNote } from './scanDeliveryNote';
import {
  type ScanDeliveryNotePayload,
  type ScanDeliveryNoteResponse,
} from './types';

/**
 * React Query mutation hook for uploading a delivery note file to DNPv2 ingestor.
 * Creates a parsing case and returns its ID. OCR and parsing continue asynchronously.
 *
 * @param options - Additional React Query mutation options
 * @returns The mutation result containing the parsing case ID on success
 *
 * @see https://app.dev.vestigas.com/redoc#tag/Parsing-Cases/operation/scan_delivery_note_v2_delivery_note_parsing_cases_post
 */
export const useMutationScanDeliveryNote = (
  options?: Omit<
    UseMutationOptions<
      ScanDeliveryNoteResponse,
      Error,
      ScanDeliveryNotePayload
    >,
    'mutationFn'
  >,
) => {
  return useMutation<ScanDeliveryNoteResponse, Error, ScanDeliveryNotePayload>({
    mutationFn: scanDeliveryNote,
    ...options,
  });
};
